import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-xz",
  "use": "icon-xz-usage",
  "viewBox": "0 0 27 29",
  "content": "<symbol xmlns:xlink=\"http://www.w3.org/1999/xlink\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 27 29\" id=\"icon-xz\">\r\n  <g transform=\"matrix(1 0 0 1 -709 -54 )\">\r\n    <path d=\"M 26 20.91494140625  L 13.47880859375 28.33193359375  L 1 20.9240234375  L 1 1  L 26 1  L 26 20.91494140625  Z M 3 3  L 3 19.71611328125  L 13.47880859375 25.87373046875  L 24 19.70400390625  L 24 3  L 3 3  Z \" fill-rule=\"nonzero\" fill=\"#fed261\" stroke=\"none\" transform=\"matrix(1 0 0 1 709 54 )\" />\r\n  </g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/xz.svg
// module id = EpEc
// module chunks = 0